/*
 * Copyright (c) 2024, Behçet Atalay
 * All rights reserved.
 *
 * @project   kaan-web
 * @author    Behçet Atalay
 * @site      https://www.technobecet.com
 * @date      21 February 2024
 */

import React from 'react';
import { Link } from 'react-router-dom';

const Portfolio = () => {
  return (
    <div className='max-w-[1920px] flex lg:flex-row lg:flex-wrap justify-center flex-col pt-8 sm:px-6 xl:px-10'>
      <div className='grow lg:basis-1/3 xl:basis-1/4 m-1'>
        <Link
          to='project/cosmopolitan'
          className='w-auto aspect-video block overflow-hidden focus-within:ring-2 focus-within:ring-indigo-500 focus-within:ring-offset-2 focus-within:ring-offset-gray-100'
        >
          <figure className='group relative transition-all duration-300 cursor-pointer'>
            <div className='absolute inset-0 bg-dark-950 opacity-0 group-hover:opacity-70 transition-opacity duration-700'></div>
            <video
              poster='https://res.cloudinary.com/drawmyqcr/image/upload/f_auto,q_auto/v1/ArtCut/cosmopolitan-poster_nfasev'
              className='w-full h-full bg-video'
              playsInline
              autoPlay
              muted
              loop
              data-object-fit='cover'
            >
              <source
                src='https://res.cloudinary.com/drawmyqcr/video/upload/f_auto:video,q_auto/v1/ArtCut/cosmopolitan_koma4v'
                type='video/mp4'
              />
              <source
                src='https://res.cloudinary.com/drawmyqcr/video/upload/f_auto:video,q_auto/v1/ArtCut/cosmopolitan_hlfewo'
                type='video/webm'
              />
            </video>
            <img
              className='absolute text-lg text-white w-1/4 bottom-1/3 left-1/2 transform -translate-x-1/2 group-hover:mb-8 transition-all duration-700'
              src='https://res.cloudinary.com/drawmyqcr/image/upload/f_auto,q_auto/v1/ArtCut/cosmopolitan_logo_zxqh77'
              alt=''
              loading='lazy'
            />
            <figcaption className='absolute px-4 w-full text-lg text-white bottom-5 text-center items-center opacity-0 group-hover:opacity-100 hover:ease-out transition-all duration-700'>
              <h4 className='font-loos text-center'>
                <strong>Urban essence glimpsed through Cosmopolitan.</strong>
              </h4>
            </figcaption>
          </figure>
        </Link>
      </div>
      <div className='grow lg:basis-1/3 xl:basis-1/4 m-1'>
        <Link
          to='project/dolce-vita'
          className='w-auto aspect-video block overflow-hidden focus-within:ring-2 focus-within:ring-indigo-500 focus-within:ring-offset-2 focus-within:ring-offset-gray-100'
        >
          <figure className='group relative transition-all duration-300 cursor-pointer'>
            <div className='absolute inset-0 bg-dark-950 opacity-0 group-hover:opacity-70 transition-opacity duration-700'></div>
            <video
              poster='https://res.cloudinary.com/drawmyqcr/image/upload/f_auto,q_auto/v1/ArtCut/dolce-poster_g88vgk'
              className='w-full h-full bg-video'
              playsInline
              autoPlay
              muted
              loop
              data-object-fit='cover'
            >
              <source
                src='https://res.cloudinary.com/drawmyqcr/video/upload/f_auto:video,q_auto/v1/ArtCut/dolce_squmet'
                type='video/mp4'
              />
              <source
                src='https://res.cloudinary.com/drawmyqcr/video/upload/f_auto:video,q_auto/v1/ArtCut/dolce_sefwd3'
                type='video/webm'
              />
            </video>
            <img
              className='absolute text-lg text-white w-1/4 bottom-1/3 left-1/2 transform -translate-x-1/2 group-hover:mb-8 transition-all duration-700'
              src='https://res.cloudinary.com/drawmyqcr/image/upload/f_auto,q_auto/v1/ArtCut/dolce_logo_ze8mvm'
              alt=''
              loading='lazy'
            />
            <figcaption className='absolute px-4 w-full text-lg text-white bottom-5 text-center items-center opacity-0 group-hover:opacity-100 hover:ease-out transition-all duration-700'>
              <h4 className='font-loos text-center'>
                <strong>
                  Elegant Visuals, Elevating Luxury: Experience the Essence of
                  Nirvana Dolce Vita.
                </strong>
              </h4>
            </figcaption>
          </figure>
        </Link>
      </div>

      <div className='grow lg:basis-1/3 xl:basis-1/4 m-1'>
        <Link
          to='project/me'
          className='w-auto aspect-video block overflow-hidden focus-within:ring-2 focus-within:ring-indigo-500 focus-within:ring-offset-2 focus-within:ring-offset-gray-100'
        >
          <figure className='group relative transition-all duration-300 cursor-pointer'>
            <div className='absolute inset-0 bg-dark-950 opacity-0 group-hover:opacity-70 transition-opacity duration-700'></div>
            <video
              poster='https://res.cloudinary.com/drawmyqcr/image/upload/f_auto,q_auto/v1/ArtCut/me-poster_wavb2p'
              className='w-full h-full bg-video'
              playsInline
              autoPlay
              muted
              loop
              data-object-fit='cover'
            >
              <source
                src='https://res.cloudinary.com/drawmyqcr/video/upload/f_auto:video,q_auto/v1/ArtCut/me_za0mds'
                type='video/mp4'
              />
              <source
                src='https://res.cloudinary.com/drawmyqcr/video/upload/f_auto:video,q_auto/v1/ArtCut/me_fzpfub'
                type='video/webm'
              />
            </video>
            <img
              className='absolute text-lg text-white w-1/4 bottom-1/3 left-1/2 transform -translate-x-1/2 group-hover:mb-8 transition-all duration-700'
              src='https://res.cloudinary.com/drawmyqcr/image/upload/f_auto,q_auto/v1/ArtCut/me_logo_ntkcr8'
              alt=''
              loading='lazy'
            />
            <figcaption className='absolute px-4 w-full text-lg text-white bottom-5 text-center items-center opacity-0 group-hover:opacity-100 hover:ease-out transition-all duration-700'>
              <h4 className='font-loos text-center'>
                <strong>
                  Uniting with Nature for Unparalleled Tranquility
                </strong>
              </h4>
            </figcaption>
          </figure>
        </Link>
      </div>
      <div className='grow lg:basis-1/3 xl:basis-1/4 m-1'>
        <Link
          to='project/badilli'
          className='w-auto aspect-video block overflow-hidden focus-within:ring-2 focus-within:ring-indigo-500 focus-within:ring-offset-2 focus-within:ring-offset-gray-100'
        >
          <figure className='group relative transition-all duration-300 cursor-pointer'>
            <div className='absolute inset-0 bg-dark-950 opacity-0 group-hover:opacity-70 transition-opacity duration-700'></div>
            <video
              poster='https://res.cloudinary.com/drawmyqcr/image/upload/f_auto,q_auto/v1/ArtCut/badilli-poster_o7n2cu'
              className='w-full h-full bg-video'
              playsInline
              autoPlay
              muted
              loop
              data-object-fit='cover'
            >
              <source
                src='https://res.cloudinary.com/drawmyqcr/video/upload/f_auto:video,q_auto/v1/ArtCut/badilli_fyv2ul'
                type='video/mp4'
              />
              <source
                src='https://res.cloudinary.com/drawmyqcr/video/upload/f_auto:video,q_auto/v1/ArtCut/badilli_sf1hje'
                type='video/webm'
              />
            </video>
            <img
              className='absolute text-lg text-white w-1/4 bottom-1/3 left-1/2 transform -translate-x-1/2 group-hover:mb-8 transition-all duration-700'
              src='https://res.cloudinary.com/drawmyqcr/image/upload/f_auto,q_auto/v1/ArtCut/badilli_logo_al5faj'
              alt=''
              loading='lazy'
            />
            <figcaption className='absolute px-4 w-full text-lg text-white bottom-5 text-center items-center opacity-0 group-hover:opacity-100 hover:ease-out transition-all duration-700'>
              <h4 className='font-loos text-center'>
                <strong>Rhythm of Badıllı</strong>
              </h4>
            </figcaption>
          </figure>
        </Link>
      </div>
      <div className='grow lg:basis-1/3 xl:basis-1/4 m-1'>
        <Link
          to='project/dome'
          className='w-auto aspect-video block overflow-hidden focus-within:ring-2 focus-within:ring-indigo-500 focus-within:ring-offset-2 focus-within:ring-offset-gray-100'
        >
          <figure className='group relative transition-all duration-300 cursor-pointer'>
            <div className='absolute inset-0 bg-dark-950 opacity-0 group-hover:opacity-70 transition-opacity duration-700'></div>
            <video
              poster='https://res.cloudinary.com/drawmyqcr/image/upload/f_auto,q_auto/v1/ArtCut/dome-poster_rz5lqa'
              className='w-full h-full bg-video'
              playsInline
              autoPlay
              muted
              loop
              data-object-fit='cover'
            >
              <source
                src='https://res.cloudinary.com/drawmyqcr/video/upload/f_auto:video,q_auto/v1/ArtCut/dome_aw5vab'
                type='video/mp4'
              />
              <source
                src='https://res.cloudinary.com/drawmyqcr/video/upload/f_auto:video,q_auto/v1/ArtCut/dome_tvq9rf'
                type='video/webm'
              />
            </video>
            <img
              className='absolute text-lg text-white w-1/4 bottom-1/3 left-1/2 transform -translate-x-1/2 group-hover:mb-8 transition-all duration-700'
              src='https://res.cloudinary.com/drawmyqcr/image/upload/f_auto,q_auto/v1/ArtCut/dome_logo_gnb7a0'
              alt=''
              loading='lazy'
            />
            <figcaption className='absolute px-4 w-full text-lg text-white bottom-5 text-center items-center opacity-0 group-hover:opacity-100 hover:ease-out transition-all duration-700'>
              <h4 className='font-loos text-center'>
                <strong>
                  Where Every Detail Crafts a Lifestyle, Not Just a Stay.
                </strong>
              </h4>
            </figcaption>
          </figure>
        </Link>
      </div>
      <div className='grow lg:basis-1/3 xl:basis-1/4 m-1'>
        <Link
          to='project/yalihan'
          className='w-auto aspect-video block overflow-hidden focus-within:ring-2 focus-within:ring-indigo-500 focus-within:ring-offset-2 focus-within:ring-offset-gray-100'
        >
          <figure className='group relative transition-all duration-300 cursor-pointer'>
            <div className='absolute inset-0 bg-dark-950 opacity-0 group-hover:opacity-70 transition-opacity duration-700'></div>
            <video
              poster='https://res.cloudinary.com/drawmyqcr/image/upload/f_auto,q_auto/v1/ArtCut/aspendos-poster_zlyxmc'
              className='w-full h-full bg-video'
              preload='auto'
              playsInline
              autoPlay
              muted
              loop
              data-object-fit='cover'
            >
              <source
                src='https://res.cloudinary.com/drawmyqcr/video/upload/f_auto:video,q_auto/v1/ArtCut/aspendos_ujqpxx'
                type='video/mp4'
              />
              <source
                src='https://res.cloudinary.com/drawmyqcr/video/upload/f_auto:video,q_auto/v1/ArtCut/aspendos_vcrwap'
                type='video/webm'
              />
            </video>
            <img
              className='absolute text-lg text-white w-1/4 bottom-1/3 left-1/2 transform -translate-x-1/2 group-hover:mb-8 transition-all duration-700'
              src='https://res.cloudinary.com/drawmyqcr/image/upload/f_auto,q_auto/v1/ArtCut/aspendos_logo_mtnzqc'
              alt=''
              loading='lazy'
            />
            <figcaption className='absolute px-4 w-full text-lg text-white bottom-5 text-center items-center opacity-0 group-hover:opacity-100 hover:ease-out transition-all duration-700'>
              <h4 className='font-loos text-center'>
                <strong>Your Daily Scene by the Sea!</strong>
              </h4>
            </figcaption>
          </figure>
        </Link>
      </div>
    </div>
  );
};

export default Portfolio;
